import { createContext, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { StatusCode } from '../../components/Alert.tsx';
import AlimentsController from '../../controllers/AlimentsController.ts';
import MediaController from '../../controllers/MediaController.ts';
import { Aliment } from '../../models/aliments/aliment.ts';
import { AlimentStore } from '../../models/aliments/alimentStore.ts';
import { useAlert } from '../alertProvider.tsx';

type AlimentContextType = {
    isLoaded?: boolean;
    aliment: Aliment;
    insertAliment: (entity: Aliment, file: any) => void;
    updateAliment: (entity: Aliment, file: any) => void;
};

const AlimentContext = createContext<AlimentContextType>({} as AlimentContextType);

export const AlimentContextProvider = ({ children, id }: { children: any, id: any }) => {
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [aliment, setAliment] = useState<Aliment>({ alimentID: 0, name: '', brand: '', measurementUnitID: 1, categoryID: 1, userID: 0, alimentStores: [] as AlimentStore[], defaultQuantity: 100 } as Aliment);
    const { showAlert } = useAlert();
    const navigate = useNavigate();

    const getAlimentByID = async () => {
        if (id == "create") { setIsLoaded(true); return; }
        try {
            const result = await AlimentsController.getByID(id);
            if (result.notificationStatus == StatusCode.success)
                setAliment(result);
            else showAlert(result.notificationStatus, result.notificationMessage);
        } catch (error) {
            console.error('Error fetching aliment:', error);
        } finally {
            setIsLoaded(true);
        }
    }

    const insertAliment = async (entity: Aliment, file: any) => {
        try {
            const result = await AlimentsController.post(entity);
            if (result.notificationStatus == StatusCode.success) {
                if (file == null) {
                    navigate(-1);
                    return;
                }
                const fileResult = await MediaController.post('Aliment', result.alimentID, file);
                if (fileResult.notificationStatus == StatusCode.success)
                    navigate(-1);
                else
                    showAlert(fileResult.notificationStatus, fileResult.notificationMessage);
            }
            else
                showAlert(result.notificationStatus, result.notificationMessage);
        } catch (error) {
            console.error('Error inserting aliment:', error);
        }
    }

    const updateAliment = async (entity: Aliment, file: any) => {
        try {
            const result = await AlimentsController.put(entity);
            if (result.notificationStatus == StatusCode.success) {
                if (file == null) {
                    navigate(-1);
                    return;
                }
                const fileResult = await MediaController.post('Aliment', entity.alimentID, file);
                if (fileResult.notificationStatus == StatusCode.success)
                    navigate(-1);
                else
                    showAlert(fileResult.notificationStatus, fileResult.notificationMessage);
            }
            else
                showAlert(result.notificationStatus, result.notificationMessage);
        } catch (error) {
            console.error('Error updating aliment:', error);
        }
    }

    useEffect(() => {
        getAlimentByID();
    }, [id]);

    const context: AlimentContextType = {
        isLoaded,
        aliment,
        insertAliment,
        updateAliment
    }

    return (
        <AlimentContext.Provider value={context}>
            {children}
        </AlimentContext.Provider>
    )
}

export const useAlimentContext = () => useContext(AlimentContext)
